<template lang="pug">
div
  v-chip(outlined light).my-4.py-5.px-5.full-width-chip
    span {{ $conf.LESSON_TYPE_NAMES[lesson.type] }}
    v-icon(right) mdi-school
  v-fade-transition(mode="out-in")
    v-progress-linear.mt-4(
      v-if="loading"
      indeterminate
      color="primary"
    )
    div(v-if="!loading && meetings")
      template(v-if="meetings.length")
        .title.mt-5 Трансляции
        lesson-meeting-card.my-3(
          v-for="meeting in meetings"
          :key="meeting.id"
          :meeting="meeting"
          :is-teacher="isTeacher"
        )
      template(v-if="lesson.tasks.length")
        .title.my-3 Задания
        lesson-task(
          v-for="(item, taskIdx) in lesson.tasks"
          :key="item.id"
          :task="item"
          :idx="taskIdx"
        )

  v-row(no-gutters).mt-5
    tooltip-wrap(
      :value="lesson.user_passed"
      text="Урок завершен. Консультация больше недоступна"
    )
      v-btn(
        depressed
        rounded
        :disabled="lesson.user_passed"
        large
        color="secondary"
        @click="lesson.openChatAsStudent()"
      )
        span.mobile-hidden.mr-2 Консультация
        v-badge(
          :value="lesson.hasConsultationMessages"
          color="error"
          size="10"
          overlap
          dot
          bordered
        )
          v-icon mdi-forum
    v-spacer
    tooltip-wrap(
      :value="lesson.isComplete"
      :text="lessonPassedText(lesson.user_passed)"
    )
      v-btn(
        @click="openApproveDialog(lesson)"
        color="success"
        rounded
        large
        :disabled="lesson.isComplete"
      ) {{ !lesson.user_passed ? "Завершить урок" : "Урок завершен" }}
</template>

<script>
import { mapGetters } from 'vuex';

import LessonMeetingCard from './LessonMeetingCard.vue';
import LessonTask from './LessonTask.vue';

export default {
  name: 'LessonList',
  components: {
    LessonMeetingCard,
    LessonTask,
  },
  props: {
    lesson: { type: Object, required: true },
  },
  data() {
    return {
      meetings: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      isTeacher: 'auth/isTeacher',
    }),
    daysAfterStart() {
      return true;
    },
    courseId() {
      return this.$route.params.courseId;
    },
    unitId() {
      return this.$route.params.unitId;
    },
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      this.loading = true;
      const params = {
        expand: 'meetings',
      };
      if (!('meetings' in this.lesson)) {
        await this.$rHandler(
          this.$api.lessons.getLesson(this.lesson.id, params),
          (r) => {
            this.meetings = r.data.data;
            return r;
          },
        );
      }
      this.loading = false;
    },
    lessonPassedText(isPassed) {
      return isPassed ? 'Урок завершен' : 'Завершить урок Вы сможете после того, как Ваше задание получит положительную оценку';
    },
    openApproveDialog(lesson) {
      this.$modals.show('confirm-controller', {
        message: `<p>Подтверждаете, что готовы перейти к следующему уроку? Возможность получения консультации
          у закрепленного эксперта по завершенному уроку будет отозвана.</p><p class="mt-2 font-weight-bold error--text">
          Точно все освоили?</p>`,
        method: () => this.$rHandler(
          this.$api.lessons.passLesson(lesson.id, {
            course_id: this.courseId,
          }),
          () => {
            this.$emit('update');
            this.$toasted.success('Урок успешно завершен', { duration: 2000 });
          },
        ),
      });
    },
  },
};
</script>
